import React from 'react'

const HomeSkills = () => {
  return (
   <>
   
  {/* tmp skill area start */}
  <div className="tmp-skill-area tmp-section-gapTop">
    <div className="container">
      <div className="row g-5">
        <div className="col-lg-6">
          <div className="progress-wrapper">
            <div className="content">
              <h2 className="custom-title mb--30 tmp-scroll-trigger tmp-fade-in animation-order-1">
                Design Skill{" "}
                <span>
                  <img
                    src="assets/images/custom-line/custom-line.png"
                    alt="custom-line"
                  />
                </span>
              </h2>
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">PHOTOSHOP</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.5s"
                    data-wow-delay=".3s"
                    role="progressbar"
                    style={{
                      width: "100%",
                      visibility: "visible",
                      animationDuration: "0.5s",
                      animationDelay: "0.3s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">100%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">FIGMA</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.6s"
                    data-wow-delay=".4s"
                    role="progressbar"
                    style={{
                      width: "95%",
                      visibility: "visible",
                      animationDuration: "0.6s",
                      animationDelay: "0.4s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">95%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">ADOBE XD</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.7s"
                    data-wow-delay=".5s"
                    role="progressbar"
                    style={{
                      width: "97%",
                      visibility: "visible",
                      animationDuration: "0.7s",
                      animationDelay: "0.5s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">97%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">ADOBE ILLUSTRATOR</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.8s"
                    data-wow-delay=".6s"
                    role="progressbar"
                    style={{
                      width: "100%",
                      visibility: "visible",
                      animationDuration: "0.8s",
                      animationDelay: "0.6s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">100%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="progress-wrapper">
            <div className="content">
              <h2 className="custom-title mb--30 tmp-scroll-trigger tmp-fade-in animation-order-1">
                Development Skill{" "}
                <span>
                  <img
                    src="assets/images/custom-line/custom-line.png"
                    alt="custom-line"
                  />
                </span>
              </h2>
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">HTML</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.5s"
                    data-wow-delay=".3s"
                    role="progressbar"
                    style={{
                      width: "100%",
                      visibility: "visible",
                      animationDuration: "0.5s",
                      animationDelay: "0.3s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">100%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">CSS</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.6s"
                    data-wow-delay=".4s"
                    role="progressbar"
                    style={{
                      width: "95%",
                      visibility: "visible",
                      animationDuration: "0.6s",
                      animationDelay: "0.4s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">95%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">Javascript</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.7s"
                    data-wow-delay=".5s"
                    role="progressbar"
                    style={{
                      width: "60%",
                      visibility: "visible",
                      animationDuration: "0.7s",
                      animationDelay: "0.5s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">60%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">Wordpress</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.8s"
                    data-wow-delay=".6s"
                    role="progressbar"
                    style={{
                      width: "70%",
                      visibility: "visible",
                      animationDuration: "0.8s",
                      animationDelay: "0.6s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">70%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="container mt-10">
      <div className="row g-5">
        <div className="col-lg-6">
          <div className="progress-wrapper">
            <div className="content">
              <h2 className="custom-title mb--30 tmp-scroll-trigger tmp-fade-in animation-order-1">
                AI & Machine Learning{" "}
                <span>
                  <img
                    src="assets/images/custom-line/custom-line.png"
                    alt="custom-line"
                  />
                </span>
              </h2>
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">Python</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.5s"
                    data-wow-delay=".3s"
                    role="progressbar"
                    style={{
                      width: "90%",
                      visibility: "visible",
                      animationDuration: "0.5s",
                      animationDelay: "0.3s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">90%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">TensorFlow</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.6s"
                    data-wow-delay=".4s"
                    role="progressbar"
                    style={{
                      width: "95%",
                      visibility: "visible",
                      animationDuration: "0.6s",
                      animationDelay: "0.4s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">95%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">PyTorch</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.7s"
                    data-wow-delay=".5s"
                    role="progressbar"
                    style={{
                      width: "97%",
                      visibility: "visible",
                      animationDuration: "0.7s",
                      animationDelay: "0.5s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">97%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">Hugging</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.8s"
                    data-wow-delay=".6s"
                    role="progressbar"
                    style={{
                      width: "80%",
                      visibility: "visible",
                      animationDuration: "0.8s",
                      animationDelay: "0.6s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">80%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="progress-wrapper">
            <div className="content">
              <h2 className="custom-title mb--30 tmp-scroll-trigger tmp-fade-in animation-order-1">
                App Development{" "}
                <span>
                  <img
                    src="assets/images/custom-line/custom-line.png"
                    alt="custom-line"
                  />
                </span>
              </h2>
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">React Native</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.5s"
                    data-wow-delay=".3s"
                    role="progressbar"
                    style={{
                      width: "90%",
                      visibility: "visible",
                      animationDuration: "0.5s",
                      animationDelay: "0.3s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">90%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">Kotlin</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.6s"
                    data-wow-delay=".4s"
                    role="progressbar"
                    style={{
                      width: "80%",
                      visibility: "visible",
                      animationDuration: "0.6s",
                      animationDelay: "0.4s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">80%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">Flutter</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.7s"
                    data-wow-delay=".5s"
                    role="progressbar"
                    style={{
                      width: "60%",
                      visibility: "visible",
                      animationDuration: "0.7s",
                      animationDelay: "0.5s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">60%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
              {/* Start Single Progress Charts */}
              <div className="progress-charts">
                <h6 className="heading heading-h6">Swift</h6>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="0.8s"
                    data-wow-delay=".6s"
                    role="progressbar"
                    style={{
                      width: "70%",
                      visibility: "visible",
                      animationDuration: "0.8s",
                      animationDelay: "0.6s",
                      animationName: "fadeInLeft"
                    }}
                    aria-valuenow={85}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    <span className="percent-label">70%</span>
                  </div>
                </div>
              </div>
              {/* End Single Progress Charts */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* tmp skill area end */}


   </>
  )
}

export default HomeSkills